import { render, staticRenderFns } from "./FreeLessonPage.vue?vue&type=template&id=b6a5b380&scoped=true&"
import script from "./FreeLessonPage.vue?vue&type=script&lang=js&"
export * from "./FreeLessonPage.vue?vue&type=script&lang=js&"
import style0 from "./FreeLessonPage.vue?vue&type=style&index=0&id=b6a5b380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a5b380",
  null
  
)

export default component.exports